import NukaCarousel from 'nuka-carousel';
import * as React from 'react';
export default class Carousel extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 200);
    }
    render() {
        return React.createElement(NukaCarousel, Object.assign({}, this.props));
    }
}
//# sourceMappingURL=index.js.map